var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3521 5.1296C2.12198 5.27343 1.93222 5.47342 1.80067 5.71077C1.66912 5.94812 1.6001 6.21503 1.6001 6.4864V12.8C1.6001 13.2243 1.76867 13.6313 2.06873 13.9314C2.36878 14.2314 2.77575 14.4 3.2001 14.4H12.8001C13.2244 14.4 13.6314 14.2314 13.9315 13.9314C14.2315 13.6313 14.4001 13.2243 14.4001 12.8V6.4864C14.4001 6.21503 14.3311 5.94812 14.1995 5.71077C14.068 5.47342 13.8782 5.27343 13.6481 5.1296L8.8481 2.1296C8.59381 1.97067 8.29997 1.8864 8.0001 1.8864C7.70023 1.8864 7.40639 1.97067 7.1521 2.1296L2.3521 5.1296ZM4.4441 7.068C4.35669 7.0097 4.25865 6.96918 4.15559 6.94876C4.05252 6.92834 3.94644 6.92842 3.8434 6.949C3.74037 6.96957 3.64239 7.01024 3.55508 7.06869C3.46776 7.12713 3.3928 7.20219 3.3345 7.2896C3.27619 7.37701 3.23567 7.47505 3.21525 7.57811C3.19483 7.68118 3.19491 7.78726 3.21549 7.8903C3.25705 8.09839 3.37957 8.28145 3.5561 8.3992L7.5561 11.0656C7.68756 11.1533 7.84206 11.2001 8.0001 11.2001C8.15814 11.2001 8.31263 11.1533 8.4441 11.0656L12.4441 8.3992C12.6206 8.28145 12.7431 8.09839 12.7847 7.8903C12.8263 7.68221 12.7835 7.46613 12.6657 7.2896C12.5479 7.11307 12.3649 6.99055 12.1568 6.949C11.9487 6.90744 11.7326 6.95025 11.5561 7.068L8.0001 9.4384L4.4441 7.068Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpen);
export default __webpack_public_path__ + "static/media/MailOpen.f1b6589a9f0374b50991f39843e94de5.svg";
export { ForwardRef as ReactComponent };